import { CommonFileType } from '@/types';
import { Button, Tooltip } from 'antd';
import { FC } from 'react';

type AudioItemProps = {
  removeFile: (value: string) => void;
  audioFile: CommonFileType;
};

const AudioItem: FC<AudioItemProps> = (props: AudioItemProps) => {
  const { audioFile, removeFile } = props;

  return (
    <div className="audio-item-wrapper">
      <audio controls>
        <source src={audioFile.preview} type={audioFile.type} />
        <track kind="captions" />
      </audio>

      <div className="audio-content">
        <Tooltip title={audioFile.name}>
          <span className="uploaded-audio-name">{audioFile.name}</span>
        </Tooltip>

        <Tooltip title="Remove">
          <Button
            size="small"
            shape="circle"
            className="icon-remove-audio"
            danger
            onClick={(e) => {
              e.stopPropagation();
              removeFile(audioFile.uniqueId || '');
            }}
          >
            <i className="fa fa-times" />
          </Button>
        </Tooltip>
      </div>
    </div>
  );
};

export default AudioItem;
